<template>
  <div
    class="flex items-center px-4 py-2 mb-4 w-full max-w-xs rounded-xl text-gray-400 bg-gray-800"
    @mouseover="this.stopDuration"
    @mouseleave="this.startDuration"
  >
    <div
      class="inline-flex flex-shrink-0 justify-center items-center w-8 h-8 rounded-3xl"
      :class="this.cssClass"
    >
      <svg
        class="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          :d="this.iconToast"
        ></path>
      </svg>
    </div>
    <div class="ml-3 text-sm" :class="{ 'font-semibold': this.toast.content }">
      {{ this.toast.title }}
      <div
        class="text-sm font-normal"
        v-if="this.toast.content"
        v-html="this.toast.content"
      ></div>
    </div>
    <button
      type="button"
      class="ml-auto flex justify-center items-center -mx-1.5 -my-1.5 rounded-xl p-1.5 h-6 w-6 text-gray-500 hover:text-white bg-gray-800 hover:bg-gray-700"
      @click="this.dismissToast"
    >
      <svg
        class="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        ></path>
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Toast",
  props: {
    toast: { required: true, type: Object },
  },
  data() {
    return {
      duration: 8000,
      intervalDuration: null,
      timeRemaining: 0,
    };
  },
  created() {
    this.startDuration();
  },
  watch: {
    timeRemaining() {
      if (this.timeRemaining >= this.getDuration) {
        this.dismissToast();
      }
    },
  },
  computed: {
    getDuration() {
      return this.toast.duration || this.duration;
    },
    iconToast() {
      let icon = "paper-plane";
      switch (this.toast.type) {
        case "success":
          icon = "M4.5 12.75l6 6 9-13.5";
          break;
        case "info":
          icon =
            "M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z";
          break;
        case "danger":
          icon = "M6 18L18 6M6 6l12 12";
          break;
        case "warning":
          icon =
            "M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z";
          break;
      }
      return icon;
    },
    cssClass() {
      let css = "text-blue-500";
      switch (this.toast.type) {
        case "success":
          css = "bg-green-800 text-green-200";
          break;
        case "info":
          css = "bg-blue-700 text-blue-200";
          break;
        case "danger":
          css = "bg-red-800 text-red-200";
          break;
        case "warning":
          css = "bg-orange-700 text-orange-200";
          break;
      }
      return css;
    },
  },
  methods: {
    startDuration() {
      this.intervalDuration = setInterval(() => {
        this.timeRemaining += 1000;
      }, 1000);
    },
    stopDuration() {
      if (this.intervalDuration) {
        clearInterval(this.intervalDuration);
      }
    },
    dismissToast() {
      this.stopDuration();
      this.$store.commit("toast/clear", this.toast.key);
    },
  },
  beforeUnmount() {
    this.stopDuration();
  },
};
</script>

<style scoped></style>
